/** @format */
import {formatSingleUserProfiles, formatUserProfiles} from '../../../../cart/helpers/format';
import {Drawer, DrawerFooter, DrawerHeader} from '@sttark/design-system';
import AddEditForm from '../../payments/add_credit_profile_form';
import {ErrorDisplay, If, IfElse} from 'frontier-utilities';
import {usePayBalance} from '../use_pay_balance';
import NumberFormat from 'react-number-format';
import {Select} from '@sttark/design-system';
import React, {useState} from 'react';

// style
import './pay_invoice.scss';

export const PayInvoice = props => {
    const {
        invoices: {carts: invoices},
        onGetPaymentProfiles,
        payment_profile_id,
        handleToggleModal,
        showInvoicesModal,
        handleRemoveItem,
        paymentProfiles,
        payMultipleList,
        isPayingSingle,
        handleAddItem,
        onChange,
        formData,
        loading,
        saving,
        error
    } = props;

    const payInvoices = usePayBalance({isPayingSingle, payMultipleList, isChargeBatch: false});
    const {handlePayment, onChooseProfile, isProcessing, paymentError} = payInvoices;

    const singleInvoice = invoices.find(({id}) => id === payMultipleList[0]) || {};
    const invoicesToPayFor = isPayingSingle ? [singleInvoice] : invoices;

    // get the total to pay for
    let total;
    // if it is a single invoice, use the total from the cart
    if (isPayingSingle) {
        total = singleInvoice.total - Number(singleInvoice.partial_payments || 0);
    } else if (invoices?.length > 0) {
        total = invoices.reduce((total, item) => {
            total += payMultipleList.indexOf(item.id) > -1 ? parseFloat(item.total) : 0;
            return total - Number(item.partial_payments || 0);
        }, 0);
    }

    const formatPaymentProfilesForDropDown =
        formatUserProfiles(paymentProfiles)?.profiles?.filter(profile => profile.value !== 'cta') ||
        [];
    const currentProfile = formatSingleUserProfiles(
        formatPaymentProfilesForDropDown.find(profile => profile.value === payment_profile_id)
    );

    const handleChange = profileId => {
        const profile = paymentProfiles.find(profile => profile.id === profileId);
        onChooseProfile(profile);
    };

    return (
        <Drawer
            onClose={() => {
                handleToggleModal('invoices');
            }}
            isOpen={showInvoicesModal}>
            <DrawerHeader
                onCancel={() => {
                    handleToggleModal('invoices');
                }}
                title={isPayingSingle ? 'Pay An Invoice' : 'Pay All Invoices'}
            />
            <div>
                <IfElse condition={loading}>
                    <div>
                        Retrieving available payment profiles...
                        <i className="fa fa-spin fa-spinner" />{' '}
                    </div>
                    <div>
                        <div className={'select-payment-method--dropdown mb-2'}>
                            <Select
                                placeholder="Select Payment method"
                                options={formatPaymentProfilesForDropDown}
                                initialValue={currentProfile}
                                label="Select Payment method"
                                onChange={handleChange}
                            />
                        </div>
                        <AddEditForm onSuccessfulSave={onGetPaymentProfiles}>
                            <button className="color-accent-primary m-0 p-0">
                                <i className="fa fa-plus" />
                                <u>Add payment method</u>
                            </button>
                        </AddEditForm>
                    </div>
                </IfElse>
                <div style={{paddingBottom: '150px'}}>
                    <h4>Included Invoices</h4>
                    <table width="100%">
                        <thead className={'bg-structure-lightest'}>
                            <tr>
                                <th className="p-3">Invoice #</th>
                                <th className="p-3">Amount Due</th>
                                <th className="p-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoicesToPayFor.map((item, index) => {
                                return (
                                    <tr key={`${item.id}-${index}`}>
                                        <td className="p-3">{item.id}</td>
                                        <td className="p-3">
                                            <NumberFormat
                                                value={
                                                    item.total - Number(item.partial_payments || 0)
                                                }
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                displayType="text"
                                                decimalScale={2}
                                                prefix={'$'}
                                            />
                                        </td>
                                        <td className="p-3">
                                            <If condition={!isPayingSingle}>
                                                <IfElse
                                                    condition={
                                                        payMultipleList.indexOf(item.id) > -1
                                                    }>
                                                    <button
                                                        onClick={() => handleRemoveItem(item.id)}
                                                        className="color-alert-negative"
                                                        id={item.id}>
                                                        <i className="fa fa-xmark" />
                                                    </button>
                                                    <button
                                                        onClick={() => handleAddItem(item.id)}
                                                        className="color-accent-primary"
                                                        id={item.id}>
                                                        <i className="fa fa-plus" />
                                                    </button>
                                                </IfElse>
                                            </If>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <IfElse condition={isProcessing}>
                <DrawerFooter>
                    <h4>Processing</h4>
                </DrawerFooter>
                <IfElse condition={!!paymentError}>
                    <DrawerFooter>
                        <ErrorDisplay className="alert alert-danger d-block" error={paymentError} />
                    </DrawerFooter>
                    <DrawerFooter
                        title={
                            <NumberFormat
                                decimalScale={2}
                                fixedDecimalScale={true}
                                displayType="text"
                                prefix="Total: $"
                                value={total}
                            />
                        }
                        okTitle={'Pay Invoices'}
                        onOk={handlePayment}
                    />
                </IfElse>
            </IfElse>
        </Drawer>
    );
};
